import React from "react";
import { Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import InputText from "../../input/inputText";
import InputPassword from "../../input/inputPassword";
import { InfoIcon } from "./../svg";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsPassword,
  setPasswordHintText,
  setPasswordValue,
} from "../../../redux/slices/settings";

const Password = () => {
  const { isPassword, passwordValue, hintText, lang } = useSelector(
    (state) => ({
      isPassword: state.settings.password.isPassword,
      passwordValue: state.settings.password.value,
      hintText: state.settings.password.hintText,
      lang: state.changeLang.language.restriction,
    })
  );
  const dispatch = useDispatch();

  return (
    <div className="mb-4">
      <div>
        <Form.Check
          type="checkbox"
          label={lang[33]}
          checked={isPassword}
          onChange={() => dispatch(setIsPassword(!isPassword))}
          id="scanLimits`"
          className="me-2 d-inline-block fw-bold"
        />
        <OverlayTrigger
          overlay={<Tooltip className="opacity-75">{lang[34]}</Tooltip>}
        >
          <div className="d-inline">
            <InfoIcon className="mb-1" />
          </div>
        </OverlayTrigger>
      </div>

      {isPassword && (
        <Row className="g-3 mt-0">
          <Col md={6}>
            <InputPassword
              value={passwordValue}
              onChange={(e) => dispatch(setPasswordValue(e.target.value))}
            />
          </Col>
          <Col md={6}>
            <InputText
              placeholder={lang[35]}
              value={hintText}
              onChange={(e) => dispatch(setPasswordHintText(e.target.value))}
              popoverText={null}
              className="mb-0"
            />
          </Col>
        </Row>
      )}
    </div>
  );
};

export default Password;
